import React from 'react';
import { formatEuro } from '@/lib/format';
import { EST_IDS } from '@/constants/testIds/estimating';

function Tile({ label, value, sub, tone = 'text-charcoal' }) {
  return (
    <div className="rounded-lg border border-border bg-white px-4 py-3">
      <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className={`mt-1 font-display font-bold text-xl tabular-nums ${tone}`}>{value}</div>
      {sub && <div className="text-[11px] text-muted-foreground mt-0.5">{sub}</div>}
    </div>
  );
}

export default function FinancialSummary({ tender, boq, cost, canSeeCost }) {
  const tenderEx = tender?.tender_subtotal_ex_vat != null ? Number(tender.tender_subtotal_ex_vat) : null;
  const boqTotal = boq?.computed_total != null ? Number(boq.computed_total) : null;
  const costTotal = cost?.computed_total != null ? Number(cost.computed_total) : null;
  const revenue = tenderEx ?? boqTotal;
  const margin = revenue != null && costTotal != null ? revenue - costTotal : null;
  const marginPct = margin != null && revenue ? (margin / revenue) * 100 : null;

  return (
    <div data-testid={EST_IDS.financialSummary} className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
      <Tile label="Tender total incl. VAT" value={formatEuro(tender?.tender_total_inc_vat)} sub={tender ? `Ex VAT ${formatEuro(tenderEx)} · VAT ${formatEuro(tender.tender_vat_amount)}` : 'No confirmed Tender Summary'} />
      <Tile label="Priced BOQ ex VAT" value={formatEuro(boqTotal)}
        sub={boq ? (boq.reconciled ? `Reconciled to ${boq.expected_source === 'tender_summary' ? 'Tender Summary' : 'manual total'}` : `Override · variance ${formatEuro(boq.reconciliation_variance)}`) : 'No confirmed Priced BOQ'} />
      {canSeeCost ? (
        <>
          <Tile label="Internal cost budget" value={formatEuro(costTotal)} sub={cost ? `v${cost.version_number} · ${cost.row_count} lines` : 'No confirmed cost budget'} />
          <Tile label="Projected gross margin" value={margin != null ? formatEuro(margin) : '—'}
            sub={marginPct != null ? `${marginPct.toFixed(1)}% of ex-VAT revenue` : 'Needs tender/BOQ and cost budget'}
            tone={margin == null ? 'text-charcoal' : margin >= 0 ? 'text-emerald-700' : 'text-red-700'} />
        </>
      ) : (
        <Tile label="Internal cost budget" value="Restricted" sub="Owner, admin and manager only" tone="text-muted-foreground" />
      )}
    </div>
  );
}
